import { dateFormat_0 } from '@/utils/frontend/dateOps';
import React, { useState, useEffect } from 'react';

const DatePicker = ({ callback, targetDate, recreationOrExpiration }) => {
    // console.log('currentSelectedDate', targetDate);

    // Function to format date to "YYYY-MM-DD" in UTC
    // const formatDate = (date) => {
    //     if (!date) return '';
    //     const d = new Date(date);
    //     const year = d.getUTCFullYear();
    //     const month = ('0' + (d.getUTCMonth() + 1)).slice(-2); // getMonth is 0-indexed
    //     const day = ('0' + d.getUTCDate()).slice(-2);
    //     return `${year}-${month}-${day}`;
    // };


        // Function to get today's date plus one month
        const todayPlusOneMonth = () => {
            const today = new Date();
            today.setUTCMonth(today.getUTCMonth() + 1); // Add one month
            return dateFormat_0(today);
        };



    // State for the selected date
    const [selectedDate, setSelectedDate] = useState(dateFormat_0(targetDate) || todayPlusOneMonth() ||  dateFormat_0(new Date()));

    useEffect(() => {
        // When targetDate changes, update the selectedDate
        setSelectedDate(dateFormat_0(targetDate) || todayPlusOneMonth() || dateFormat_0(new Date()));
        // Optionally call callback on component mount or update
        // if (targetDate) {
        //     callback({ datePicker: formatDate(targetDate) });
        // } 
        // else {

        //     const today = new Date();
        //     callback({ datePicker: today });
        // }
    }, [targetDate]);

    const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
        callback({ datePicker: event.target.value, recreationOrExpiration: recreationOrExpiration });
    };

    return (
        <div className="w-full">
            <input
                type="date"
                value={selectedDate}
                onChange={handleDateChange}
                className="bg-inherit px-3 w-full py-4 border border-slate-300 dark:border-slate-600 rounded-lg text-sm focus:outline-none focus:border-blue-500"
            />
        </div>
    );
};

export default DatePicker;


// import React, { useState, useEffect } from 'react';

// const DatePicker = ({ callback, targetDate }) => {
//     console.log('currentSelectedDate', targetDate);

//     // Function to format date to "YYYY-MM-DD"
//     const formatDate = (date) => {
//         if (!date) return '';
//         const d = new Date(date);
//         const year = d.getFullYear();
//         const month = ('0' + (d.getMonth() + 1)).slice(-2); // getMonth is 0-indexed
//         const day = ('0' + d.getDate()).slice(-2);
//         return `${year}-${month}-${day}`;
//     };

//     // State for the selected date
//     const [selectedDate, setSelectedDate] = useState(formatDate(targetDate) || formatDate(new Date()));

//     useEffect(() => {
//         // When targetDate changes, update the selectedDate
//         setSelectedDate(formatDate(targetDate) || formatDate(new Date()));
//         // Optionally call callback on component mount or update
//         if (targetDate) {
//             callback({ datePicker: formatDate(targetDate) });
//         } else {
//             const today = formatDate(new Date());
//             callback({ datePicker: today });
//         }
//     }, [targetDate]);

//     const handleDateChange = (event) => {
//         setSelectedDate(event.target.value);
//         callback({ datePicker: event.target.value });
//     };

//     return (
//         <div className="w-full">
//             <input
//                 type="date"
//                 value={selectedDate}
//                 onChange={handleDateChange}
//                 className="bg-inherit px-4 w-full py-2 border border-gray-300 dark:border-gray-700 rounded-md focus:outline-none focus:border-blue-500"
//             />
//         </div>
//     );
// };

// export default DatePicker;



// import React, { useState, useEffect } from 'react';
// import { dateFormat_0 } from '@/utils/frontend/dateOps';

// const DatePicker = ({ callback, targetDate }) => {
//      console.log('curSelDat', targetDate)
//   const [selectedDate, setSelectedDate] = useState('');
//   const [today, setToday] = useState('')


//     useEffect(() => {
//       const today = new Date();
//       const formattedToday = today.toISOString().split('T')[0]; // Get the ISO date string
//      //  const currentlySelectedDate = dateFormat_0(targetDate)
//      let x = new Date(targetDate)
//      let f = `${x.getUTCFullYear()}-${x.getMonth()}-${x.getUTCDate()}`
//      console.log('ladate', f)

//       console.log(targetDate)
//       // targetDate = targetDate.toISOString()
//       // targetDate = targetDate.setHours(0,0,0,0)
//      //  setSelectedDate(currentlySelectedDate || formattedToday);
//       setSelectedDate(f || formattedToday);
//       callback({ datePicker: formattedToday });
//     }, [targetDate]);

//   const handleDateChange = (event) => {
//     setSelectedDate(event.target.value);
//     callback({ datePicker: event.target.value });
//   };
  
//   return (
//     <div className="w-full">
//       <input
//      //  placeholder={targetDate}
//         type="date"
//         value={selectedDate}
//         onChange={handleDateChange}
//         className="bg-inherit px-4 w-full py-2 border border-gray-300 dark:border-gray-700 rounded-md focus:outline-none focus:border-blue-500"
//       />
//     </div>
//   );
// };

// export default DatePicker;

// // import React, { useState } from 'react';

// // const Datepicker = ({callback}) => {
// //   const [selectedDate, setSelectedDate] = useState('');

// //   // const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
// //   const today = new Date()
// //   const todayFormatted = `${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`



// //   const handleDateChange = (event) => {
// //     setSelectedDate(event.target.value);
// //     callback({task_due_date: event.target.value})
// //   };

// //   return (
// //     <div className="w-full" >
// //       {/* <label className="block text-gray-700 dark:text-gray-300 text-sm font-semibold mb-2">
// //         Select Date:
// //       </label> */}
// //       <input
// //         type="date"
// //         value={today}
// //         // placeholder={selectedDate || todayFormatted}
// //         onChange={handleDateChange}
// //         className="bg-inherit px-4 w-full py-2 border border-gray-300 dark:border-gray-700 rounded-md focus:outline-none focus:border-blue-500"
// //       />
// //       {/* {selectedDate && (
// //         <p className="text-gray-600 dark:text-gray-300 mt-2">
// //           Selected Date: {selectedDate}
// //         </p>
// //       )} */}
// //     </div>
// //   );
// // };

// // export default Datepicker;
